<template>
    <modal @close="cancel" dialog="modal-lg" class="dark-top" :header="false" :customClass="'heightAuto'" :footer="false">
        <div slot="body" class="p-4">
            <div>
				<h2 class="text-center mb-3">Rebook reservation for:</h2>
				<div class="d-flex h-100 justify-content-between align-items-center py-4">
					<button @click="clickedSameProduct()" class="w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer">Same product</button>
					<div class="w-25 d-flex justify-content-center"><span> - OR - </span></div>
					<button @click="clickedOtherProduct()" class="w-100 w-100 mb-2 bg-lightest color-6 text-center font-weight-600 py-3 border-light radius-normal pointer">Other product</button>
				</div>
				<div v-if="isPaymentLinkActive">
					<div class="border-top-light my-2"></div>
					<div class="pt-2">
						<p class="bold fs-large">Please note:</p>
						<p class="dark mt-1 text-break">When rebooking, the current payment link will be deactivated. A new payment link will be generated and sent by email to the customer.</p>
					</div>
				</div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { reservationsMixin } from '@/mixins/reservations'
import Modal from './Modal'

export default {
  	mixins:[
		reservationsMixin
	], 
    mounted: async function () {
		this.reservation = this.getClonedReservation;
		this.$nextTick(() => {
			this.eventHub.$on("closeTargetModal", () => {
			this.cancel();
			});
		});
	},
	destroyed: function(){
		this.eventHub.$off('closeTargetModal')
	},
	data: function() {
		return {
			reservation: null,
		}
	},
	computed: {
		...mapGetters([
			'getClonedReservation'
		]),
		isPaymentLinkActive() {
			if(this.reservation){
				return this.reservation.bookingBillingPaymentLink;
			}
		}
	},
	methods: {
		...mapActions([
			'openModal',
			'closeModal',
			'clearClonedReservation'
		]),
		cancel: function() {
			this.clearClonedReservation()
			this.closeModal();
		},
		clickedSameProduct() {
			this.$router.push('/reservation/reschedule/'+this.reservation.event.product.id);
			this.closeModal();
			this.closeModal();
		},
		clickedOtherProduct() {
			this.$router.push('/reservation/rebook/'+this.reservation.id);
			this.closeModal();
			this.closeModal();
		}
  	},
	components: {
		Modal,
	},
};
</script>
<style scoped lang="scss">
	.word-break {
		word-break: break-all;
	}    
</style>



// WEBPACK FOOTER //
// RebookChooseProduct.vue?4106598c